export default __webpack_public_path__ + "media/portrait/logo_heineken-376df0a6.svg";